import React, { SVGProps } from 'react';

const SvgPictures2 = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<path
					d='M3.5 21h17a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0020.5 7H10L7.44 4.44A1.5 1.5 0 006.378 4H3.5A1.5 1.5 0 002 5.5v14A1.5 1.5 0 003.5 21z'
					fill='currentColor'
					opacity={0.3}
				/>
				<circle fill='currentColor' opacity={0.3} cx={13.5} cy={16.5} r={2.5} />
				<circle fill='currentColor' opacity={0.3} cx={10.5} cy={16.5} r={2.5} />
				<circle fill='currentColor' opacity={0.3} cx={9.5} cy={13.5} r={2.5} />
				<circle fill='currentColor' opacity={0.3} cx={14.5} cy={13.5} r={2.5} />
				<circle fill='currentColor' opacity={0.3} cx={12} cy={11.5} r={2.5} />
			</g>
		</svg>
	);
};

export default SvgPictures2;
